/* eslint-disable react/jsx-props-no-spreading,react/destructuring-assignment */
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Switch } from "react-router-dom";
import RouteWithSubRoutes from "../../router/RouteWithSubRoutes";
import AccountListContainerTs from "../AccountListContainerTs/AccountsListContainerTs";
import AccountsIndividualContainerTs from "../AccountsIndividualContainerTs/AccountsIndividualContainerTs";
import { FormFieldValue } from "../../lib/interfaces/FormFieldValue";
import { AnyObject } from "../../lib/interfaces/AnyObject";
import { IindividualSearchValues } from "../../lib/interfaces/IindividualSearchValues";
import { fetchConfigData } from "../../store/slices/config";

function AccountsContainer(props) {
  const dispatch = useDispatch();
  const [advancedSearchFormValues, setAdvancedSearchFormValues] = useState<
    FormFieldValue[] | undefined
  >();
  const [searchByNameFields, setSearchByNameFields] = useState<FormFieldValue[] | undefined>();
  const [isPageableSearch, setIsPageableSearch] = useState(false);

  const initialIndividualSearchValues: IindividualSearchValues = {
    fullName: undefined,
    phone: undefined,
    email: undefined,
    id: undefined,
    agreementNumber: undefined,
    accountStatusId: undefined,
    agreementId: undefined,
    externalId: undefined,
    page: 0,
  };

  const [individualSearchFullName, setIndividualSearchFullName] = useState<string>("");
  const [individualSearchValues, setIndividualSearchValues] = useState<IindividualSearchValues>(
    initialIndividualSearchValues
  );

  useEffect(() => {
    dispatch(fetchConfigData());
  }, []);

  const handleSetIndividualSearchValues = (prop: AnyObject): void => {
    setIndividualSearchValues((prev) => ({ ...prev, ...prop }));
  };

  return (
    <Switch>
      {props.routes.map((route) => {
        if (route.component === AccountListContainerTs) {
          return (
            <RouteWithSubRoutes
              key={route.path}
              {...route}
              routeProps={{
                isPageableSearch,
                setIsPageableSearch,
                advancedSearchFormValues,
                setAdvancedSearchFormValues,
                searchByNameFields,
                setSearchByNameFields,
              }}
            />
          );
        }
        if (route.component === AccountsIndividualContainerTs) {
          return (
            <RouteWithSubRoutes
              key={route.path}
              {...route}
              routeProps={{
                individualSearchValues,
                handleSetIndividualSearchValues,
                individualSearchFullName,
                setIndividualSearchFullName,
                initialIndividualSearchValues,
              }}
            />
          );
        }
        return <RouteWithSubRoutes key={route.path} {...route} />;
      })}
    </Switch>
  );
}

export default AccountsContainer;
